import "./index.scss";
import "../src/assets/hot-fixes.scss";
import "rsuite/dist/rsuite.min.css";
import AppRoutes from "./appRoutes";
import { Toaster } from "react-hot-toast";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import config from "./config.json";
import { IntlProvider } from "react-intl";
import { useState } from "react";
import French from "./i18n/fr.json";
import English from "./i18n/en.json";
import ApiServices from "./service/apiService";

library.add(fas, far);

export default function App() {
  console.log("inside app tsx");

  const [locale, setLocale] = useState("en");
  const messages = loadLocaleData(locale);
  // Amplify.configure(config.amplify);

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.amplify.Auth.userPoolId,
        userPoolClientId: config.amplify.Auth.userPoolWebClientId,
        identityPoolId: config.amplify.Auth.identityPoolId,
      },
    },
    Storage: {
      S3: {
        bucket: config.Storage.AWSS3.bucket,
        region: config.Storage.AWSS3.region,
      },
    },
    API: {
      Events: {
        endpoint: config.Events.endpoint,
        region: config.Events.region,
        defaultAuthMode: "apiKey" as const,
        apiKey: config.Events.apiKey,
      },
      REST: {
        MyAPI: {
          endpoint: config.API.URL,
          region: config.Storage.AWSS3.region, // Using same region as S3
        },
      },
    },
  });

  function loadLocaleData(locale: string) {
    switch (locale) {
      case "fr":
        return French;
      default:
        return English;
    }
  }

  // const history = useHistory(); // Create a history object to manage navigation

  // // State to track the current authentication state
  // const [authState, setAuthState] = useState<string | undefined>(undefined);

  // useEffect(() => {
  //   // Add an event listener to handle changes in authentication state
  //   const listener = async (state: string, data: any) => {
  //     if (state === "signedin") {
  //       // Redirect the user to the /dashboard route upon successful sign-in
  //       history.push("/dashboard");
  //     }
  //     setAuthState(state);
  //   };

  //   // Subscribe to the event
  //   Auth.currentAuthenticatedUser()
  //     .then((user) => {
  //       setAuthState("signedin");
  //     })
  //     .catch((err) => {
  //       setAuthState("signIn");
  //     });

  //   const subscription = Auth.subscribe(listener);

  //   return () => {
  //     // Unsubscribe from the event when the component is unmounted
  //     subscription.unsubscribe();
  //   };
  // }, [history]);

  // Amplify.configure({
  //   Auth: {
  //     Cognito: {
  //       userPoolId: config.amplify.Auth.userPoolId,
  //       userPoolClientId: config.amplify.Auth.userPoolWebClientId,
  //       identityPoolId: config.amplify.Auth.identityPoolId,
  //     },
  //   },
  //   Storage: {
  //     S3: {
  //       bucket: config.Storage.AWSS3.bucket,
  //       region: config.Storage.AWSS3.region,
  //     },
  //   },
  //   API: {
  //     GraphQL: {
  //       endpoint: config.Events.endpoint,
  //       region: config.Events.region,
  //       defaultAuthMode: "apiKey" as const,
  //       apiKey: config.Events.apiKey,
  //     },
  //     REST: {
  //       MyAPI: {
  //         endpoint: config.API.URL,
  //         region: config.Storage.AWSS3.region, // Using same region as S3
  //       },
  //     },
  //   },
  // });
  return (
    <div>
      <Authenticator hideSignUp>
        <IntlProvider locale={locale} defaultLocale={"en"} messages={messages}>
          <AppRoutes></AppRoutes>
        </IntlProvider>
        <Toaster toastOptions={{ duration: 5000, position: "bottom-center" }} />
      </Authenticator>
    </div>
  );
}
